import { Box, LinearProgress, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

interface SimulatedProgressProps {
  title?: string;
  description?: string;
  defaultTime?: number;
}

export function SimulatedProgress({
  title,
  description,
  defaultTime = 8000,
}: SimulatedProgressProps) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const baseProgressStep = 100 / (defaultTime / 100);

    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        const progressStep =
          oldProgress >= 70
            ? baseProgressStep * 0.15 // Significantly slower after 70%
            : baseProgressStep; // Normal speed before 70%

        const diff = Math.random() * progressStep;
        const next = Math.min(oldProgress + diff, 100);
        if (next === 100) {
          clearInterval(timer);
        }
        return next;
      });
    }, 100);

    return () => {
      clearInterval(timer);
    };
  }, [defaultTime]);

  return (
    <Box sx={{ width: '100%', maxWidth: 400 }}>
      {title && (
        <Typography variant="h6" align="center" gutterBottom>
          {title}
        </Typography>
      )}
      <LinearProgress variant="determinate" value={progress} />
      {description && (
        <Typography variant="body2" align="center" sx={{ mt: 1 }}>
          {description}
        </Typography>
      )}
    </Box>
  );
}
